module.exports = __webpack_public_path__ + "img/folder2.a901cbc8.png";